<div class="header-bar">
  <h1>
    {{ _title }} <small>{{ this._emailTemplate.code }}</small>
  </h1>
</div>
<p-tabView>
  <p-tabPanel header="Email Template">
    <form #form="ngForm" class="email-template-form">
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-grid-row">
          <label for="code" class="ui-grid-col-2 control-label">
            <strong> <span class="required">*</span>Code:</strong>
          </label>
          <div class="label-content ui-grid-col-3">
            <input
              id="code"
              name="code"
              type="text"
              class="form-control"
              [(ngModel)]="_emailTemplate.code"
              #code="ngModel"
              pInputText
              required
              [serverValidate]="_checkCodeEndpoint"
              [disabled]="_emailTemplate.isSystem"
              [queryParams]="{ id: _emailTemplate.id }"
            />
          </div>
          <div [hidden]="!code.hasError('required') || code.untouched" style="color: red">
            Code is required
          </div>
          <div [hidden]="!code.hasError('serverValidate') || code.untouched" style="color: red">
            Code must be unique
          </div>
        </div>

        <div class="ui-grid-row">
          <label for="title" class="ui-grid-col-2 control-label">
            <strong> <span class="required">*</span>Title:</strong>
          </label>
          <div class="label-content ui-grid-col-3">
            <input
              id="title"
              name="title"
              type="text"
              class="form-control"
              [(ngModel)]="_emailTemplate.title"
              #title="ngModel"
              pInputText
              required
            />
          </div>
          <div [hidden]="title.valid || title.untouched" style="color: red">Title is required</div>
        </div>

        <!-- <div class="ui-grid-row" [hidden]="true">
                          <label for="from" class="ui-grid-col-2 control-label">
                              <strong>
                                  <span class="required">*</span>From:</strong>
                          </label>
                          <div class="label-content ui-grid-col-3">
                              <input id="from" name="from" type="text" class="form-control" [(ngModel)]="_emailTemplate.from" #from="ngModel" pInputText
                                  required />
                          </div>
                          <div [hidden]="from.valid || from.untouched" style="color:red">
                              From is required
                          </div>
                      </div> -->

        <div class="ui-grid-row">
          <label for="from" class="ui-grid-col-2 control-label">
            <strong> <span class="required">*</span>Subject:</strong>
          </label>
          <div class="label-content ui-grid-col-3">
            <input
              id="subject"
              name="subject"
              type="text"
              class="form-control"
              [(ngModel)]="_emailTemplate.subject"
              #subject="ngModel"
              pInputText
              required
            />
          </div>
          <div [hidden]="subject.valid || subject.untouched" style="color: red">
            Subject is required
          </div>
        </div>

        <!--<div class="ui-grid-row">
                          <label for="from" class="ui-grid-col-2 control-label">
                              <strong><span class="required">*</span>Body:</strong></label>
                          <div class="label-content ui-grid-col-7">
                                  <textarea id="body" name="body" class="form-control" rows="10"
                                  [(ngModel)]="_emailTemplate.body" #body="ngModel" pInputText required ></textarea>
                          </div>
                          <div [hidden]="body.valid || body.untouched" style="color:red">
                              Body is required
                          </div>
                      </div>-->

        <div class="ui-grid-row">
          <label for="from" class="ui-grid-col-2 control-label">
            <strong> <span class="required">*</span>Body:</strong>
          </label>
          <div class="label-content ui-grid-col-7">
            <quill-editor
              id="message"
              name="message"
              [(ngModel)]="_emailTemplate.body"
              [modules]="quillModules"
              [style]="{ height: '320px' }"
            ></quill-editor>
          </div>
        </div>
      </div>
      <div class="ui-grid-row">
        <button
          pButton
          type="button"
          [routerLink]="['/app/email-templates']"
          label="Cancel"
          class="ui-button-tertiary"
        ></button>
        <button
          pButton
          type="submit"
          [disabled]="form.invalid"
          (click)="save()"
          label="Save"
          class="ui-button-primary"
        ></button>
      </div>
    </form>
  </p-tabPanel>

  <p-tabPanel header="Email Template Parameters">
    <p-table
      [value]="page.items"
      [lazy]="true"
      [rows]="10"
      [responsive]="true"
      [paginator]="dataTableSettings.isPaginator"
      [rowsPerPageOptions]="[5, 10]"
      [pageLinks]="3"
      [totalRecords]="page.total"
      (onLazyLoad)="onGridLazyLoad($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="title">Title</th>
          <th>Notes</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <span>{{ item.title }}</span>
          </td>
          <td>
            <span>{{ item.notes }}</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-tabPanel>
</p-tabView>
